import { markRaw } from 'vue';
import VpModuleNav from './VpModuleNav.vue';

/**
 * The module's header, as every Virtual Profiler route hands it to the shell (`meta.sectionNav`).
 *
 * One reference for all of them, so the shell draws the same component on every screen and never
 * remounts it between two of them. Raw because it travels inside route meta: a component object
 * made reactive by whatever wraps the route would cost a proxy for nothing, and Vue warns about it.
 */
export const VP_SECTION_NAV = markRaw(VpModuleNav);
